import React, { useState } from 'react';
import AddOnsForm from './AddOnsForm';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { postAPI_Create_AddOns } from '../../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import Validation from '../../../../../../../components/Validation';
function CreateAddOnsForm({ propertyId }) {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const handleSubmit = data => {
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Create_AddOns}/${propertyId}`,
      data,
    })
      .then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      })
      .catch(err => {
        console.log('err', err);
      });
  };

  return (
    <div>
      <Button
        color="primary"
        outline
        size="lg"
        onClick={() => {
          setVisible(!visible);
        }}
        style={{ width: '100%', borderRadius: '6px' }}
      >
        + Create a New Add-on
      </Button>
      <AddOnsForm
        formLabel="Create a New Add-on"
        visible={visible}
        toggle={() => {
          setVisible(!visible);
        }}
        submit={handleSubmit}
        propertyId={propertyId}
      />
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>

  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(CreateAddOnsForm));

CreateAddOnsForm.propTypes = {
  propertyId: PropTypes.string.isRequired,
};
